import styled from 'styled-components'

const MoreButton = styled.button`
  display: block;
  text-decoration: none !important;

  appearance: none;
  background: none;
  border: 0;
  border-radius: 0;
  outline: 0;

  color: ${({ theme }) => theme.brand.jungle};
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;

  padding-left: 0;
  padding-top: 16px;
  margin-top: 8px;
`

export default MoreButton
